//
//
//
//
//
//

export default {
    name: 'BOTTOM_TIP'
}
